// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"72":"2aaaca3e","682":"c5c39565","822":"bbf6cc0d"}[chunkId] + ".js";
};